<template>
<tr>
    <td class="cell-execution"><strong class="d-block d-md-none text-dark">{{ $t('actionRow.title') }}</strong>
        <span v-html="action.toString()"></span>
    </td>
    <td class="cell-switch">
        <div>
            <input type="checkbox" :id="'action' + action.id" checked data-switch="bool" v-model="action.is_active"/>
            <label :for="'action' + action.id" :data-on-label="$t('common.yes')" :data-off-label="$t('common.no')" class="mt-1"></label>
        </div>
    </td>
    <td class="cell-action">
        <a href="javascript:void(0);" class="action-icon" @click="onEdit(action)" data-bs-toggle="modal" data-bs-target="#openActionModal">
            <i class="mdi mdi-pencil"></i>
        </a>
        <a href="javascript: void(0);" class="action-icon text-danger" @click="onDelete(action.id)">
            <i class="mdi mdi-delete"></i>
        </a>
    </td>
</tr>
</template>

<script>
export default {
    name: 'ActionRow',
    props: {
        actionValue: {
            type: Object,
            required: true
        },
        onEdit: {
            type: Function,
            required: true
        },
        onDelete: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            action: this.actionValue,
        };
    },
    watch: {
        actionValue: {
            handler(newAction) {
                this.action = newAction;
            },
            deep: true
        }
    },   
}
</script>
